import { createTheme, type MantineColorsTuple, type MantineThemeOverride } from '@mantine/core';

const buzz: MantineColorsTuple = [
  '#e7f5ff',
  '#cfe4ff',
  '#a3c8ff',
  '#73a8ff',
  '#4b8cff',
  '#3179ff',
  '#206bff',
  '#0d59e5',
  '#004ecf',
  '#0044b8',
];

const brand: MantineColorsTuple = [
  '#eef6ff',
  '#d7e6ff',
  '#abc8ff',
  '#7da8ff',
  '#578dff',
  '#3f7dff',
  '#3074ff',
  '#2363e5',
  '#1856cd',
  '#0048b6',
];

export const themeOverride: MantineThemeOverride = {
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 4 },
  defaultRadius: 'md',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: '600',
  },
  colors: { brand, buzz },
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '88em',
  },
  cursorType: 'pointer',
};

export const theme = createTheme(themeOverride);

export type AppTheme = typeof theme;
